import { Component, input } from '@angular/core';
import type { ILocation } from '../../../../../shared/interfaces/ILocation';
import { TabPersonDetailComponent } from './tab-person-detail/tab-person-detail.component';
import { TranslatePipe } from '@ngx-translate/core';
import type { PersonDetail } from '../../../../../shared/interfaces/person-detail.interface';

@Component({
    selector: 'app-tab-person',
    templateUrl: './tab-person.component.html',
    styleUrls: ['./tab-person.component.scss'],
    imports: [TabPersonDetailComponent, TranslatePipe]
})
export class TabPersonComponent {
    public readonly location = input.required<ILocation>();
    public readonly userDetail = input<PersonDetail | null>(null);
}
